import { AdminContext } from 'constants/contexts';
import {
  useContext,
} from 'react';

const CRM_ORGANIZATIONS = [105, 145, 152, 156, 148, 146];

function useRedirectUrl() {
  const { organizationId } = useContext(AdminContext);

  const url = CRM_ORGANIZATIONS.includes(organizationId) ? 'https://admin.omnirev.ai' : 'https://admin.nibble.io';

  return url;
}

export default useRedirectUrl;
